import { Alert, Button, Select } from '@piggytechng/component-library';
import './PasswordAndOTP.scss';
import { useState } from 'react';
import { OverideButtonStyle, OverideSelectStyle } from '../../../../helpers/utils';
import useRolePermissions from '../../../../hooks/useRolePermissions';
import useCustomers from '../../../../hooks/useCustomers';
import { useParams } from 'react-router-dom';
import ModalOTP from '../../../../components/Modals/ModalOTP';

const PasswordAndOTP = () => {
  const { id } = useParams();
  const [selectAction, setAction] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [otpData, setOtpData] = useState<any>(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const { restrictActionByRole } = useRolePermissions({});
  const { generateOtp, isGeneratingOtp, resetLoginCredentials, isRunningUserAction } = useCustomers();

  const [actions] = useState([
    { value: 'generate-password', label: 'Generate Password' },
    { value: 'send-otp', label: 'Send OTP' },
    // { value: 'generate-user-otp', label: 'Generate User OTP' },
    { value: 're-generate-pin', label: 'Re-generate PIN' },
  ]);

  const style = { ...OverideSelectStyle, style: { ...OverideSelectStyle.style, zIndex: undefined } };

  const requiresPassword = ['generate-password', 'send-otp', 're-generate-pin'].includes(selectAction);

  const handleSubmit = async (e: { preventDefault: () => void; target: any }) => {
    e.preventDefault();

    let actionType = '';

    if (!selectAction) {
      Alert.error('Please select an action');
      return;
    }

    selectAction === 'generate-password' && (actionType = 'resetPassword');
    selectAction === 'send-otp' && (actionType = 'sendOtp');
    selectAction === 'generate-user-otp' && (actionType = 'generateOtp');
    selectAction === 're-generate-pin' && (actionType = 'resetPin');

    if (restrictActionByRole('passwordAndOtp', actionType)) return;

    if (requiresPassword && !adminPassword) {
      Alert.error('Please enter your password');
      return;
    }

    if (selectAction === 'generate-user-otp' || selectAction === 'send-otp') {
      const data = await generateOtp(id!);
      if (data) {
        setOtpData(data);
        // setShowOtpModal(true);
      }
      return;
    }

    if (selectAction === 'generate-password') {
      await resetLoginCredentials(adminPassword, 'password', () => {
        setAdminPassword('');
        setAction('');
      });
      return;
    }

    if (selectAction === 're-generate-pin') {
      await resetLoginCredentials(adminPassword, 'pin', () => {
        setAdminPassword('');
        setAction('');
      });
      return;
    }

    Alert.success('Action performed successfully');
    setAdminPassword('');
    setAction('');
  };

  return (
    <form className="password-and-otp" onSubmit={handleSubmit}>
      <Select
        label="Select action"
        {...style}
        labelStyle={{ color: '#666766' }}
        backgroundColor="#F9FAFB"
        outlineColor="none"
        height="60px"
        placeholder="Select option"
        value={selectAction}
        onChange={(e: any) => setAction(e)}
        options={actions}
      />

      {requiresPassword && (
        <div className="password-field">
          <label
            htmlFor="admin-password"
            style={{ color: '#666766', fontSize: '14px', marginBottom: '8px', display: 'block' }}
          >
            Enter your password to confirm
          </label>
          <input
            id="admin-password"
            type="password"
            name="password"
            value={adminPassword}
            onChange={(e) => setAdminPassword(e.target.value)}
            placeholder="Enter your password"
            style={{
              width: '100%',
              height: '50px',
              border: '1px solid #e6ebf0',
              borderRadius: '8px',
              padding: '0 16px',
              fontSize: '14px',
              fontFamily: 'Jakarta',
              outline: 'none',
              backgroundColor: '#F9FAFB',
            }}
          />
        </div>
      )}

      <div>
        <Button
          type="submit"
          loading={isGeneratingOtp || isRunningUserAction}
          {...OverideButtonStyle}
          style={{
            fontFamily: 'Jakarta',
            width: '360px',
          }}
        >
          {selectAction === 'send-otp'
            ? 'Reset OTP'
            : selectAction === 'generate-user-otp'
              ? 'Generate User OTP'
              : selectAction === 're-generate-pin'
                ? 'Re-generate PIN'
                : 'Submit'}
        </Button>
      </div>

      <ModalOTP
        modalIsOpen={showOtpModal}
        setIsOpen={setShowOtpModal}
        otp={otpData?.otp || otpData?.code || 'N/A'}
        text="Generated User OTP"
      />
    </form>
  );
};
export default PasswordAndOTP;
